import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _BookmarkMenu;
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { array, fn } from "@ember/helper";
import { action } from "@ember/object";
import didInsert from "@ember/render-modifiers/modifiers/did-insert";
import { inject as service } from "@ember/service";
import DButton from "discourse/components/d-button";
import DropdownMenu from "discourse/components/dropdown-menu";
import BookmarkModal from "discourse/components/modal/bookmark";
import { popupAjaxError } from "discourse/lib/ajax-error";
import { TIME_SHORTCUT_TYPES, timeShortcuts } from "discourse/lib/time-shortcut";
import icon from "discourse-common/helpers/d-icon";
import i18n from "discourse-common/helpers/i18n";
import I18n from "discourse-i18n";
import DMenu from "float-kit/components/d-menu";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
let BookmarkMenu = (_class = (_BookmarkMenu = class BookmarkMenu extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "modal", _descriptor, this);
    _initializerDefineProperty(this, "currentUser", _descriptor2, this);
    _initializerDefineProperty(this, "toasts", _descriptor3, this);
    _initializerDefineProperty(this, "site", _descriptor4, this);
    _initializerDefineProperty(this, "quicksaved", _descriptor5, this);
    _defineProperty(this, "bookmarkManager", this.args.bookmarkManager);
    _defineProperty(this, "timezone", this.currentUser?.user_option?.timezone || moment.tz.guess());
    _defineProperty(this, "timeShortcuts", timeShortcuts(this.timezone));
    _defineProperty(this, "bookmarkCreatePromise", null);
  }
  setReminderShortcuts() {
    this.reminderAtOptions = [this.timeShortcuts.twoHours(), this.timeShortcuts.tomorrow(), this.timeShortcuts.threeDays()];
    // So the label is a simple 'Custom...'
    const custom1 = this.timeShortcuts.custom();
    custom1.label = "time_shortcut.custom_short";
    this.reminderAtOptions.push(custom1);
  }
  get existingBookmark() {
    return this.bookmarkManager.trackedBookmark?.id ? this.bookmarkManager.trackedBookmark : null;
  }
  get showEditDeleteMenu() {
    return this.existingBookmark && !this.quicksaved;
  }
  get buttonTitle() {
    if (!this.existingBookmark) {
      return I18n.t("bookmarks.not_bookmarked");
    } else {
      if (this.existingBookmark.reminderAt) {
        return I18n.t("bookmarks.created_with_reminder_generic", {
          date: this.existingBookmark.formattedReminder(this.timezone),
          name: this.existingBookmark.name || ""
        });
      } else {
        return I18n.t("bookmarks.created_generic", {
          name: this.existingBookmark.name || ""
        });
      }
    }
  }
  get buttonClasses() {
    let cssClasses1 = ["bookmark widget-button bookmark-menu__trigger"];
    if (!this.args.showLabel) {
      cssClasses1.push("btn-icon no-text");
    } else {
      cssClasses1.push("btn-icon-text");
    }
    if (this.args.buttonClasses) {
      cssClasses1.push(this.args.buttonClasses);
    }
    if (this.existingBookmark) {
      cssClasses1.push("bookmarked");
      if (this.existingBookmark.reminderAt) {
        cssClasses1.push("with-reminder");
      }
    }
    return cssClasses1.join(" ");
  }
  get buttonIcon() {
    if (this.existingBookmark?.reminderAt) {
      return "discourse-bookmark-clock";
    } else {
      return "bookmark";
    }
  }
  get buttonLabel() {
    if (!this.args.showLabel) {
      return;
    }
    if (this.existingBookmark) {
      return I18n.t("bookmarked.edit_bookmark");
    } else {
      return I18n.t("bookmarked.title");
    }
  }
  reminderShortcutTimeTitle(option1) {
    if (!option1.time) {
      return "";
    }
    return option1.time.format(I18n.t(option1.timeFormatKey));
  }
  onBookmark() {
    this.bookmarkCreatePromise = this.bookmarkManager.create();
    this.bookmarkCreatePromise.then(() => {
      // We show the menu with Edit/Delete options if the bokmark exists,
      // so this "quicksave" will do nothing in that case.
      // NOTE: Need a nicer way to handle this; otherwise as soon as you save
      // a bookmark, it switches to the other Edit/Delete menu.
      this.quicksaved = true;
      this.toasts.success({
        duration: 1500,
        views: ["mobile"],
        data: {
          message: I18n.t("bookmarks.bookmarked_success")
        }
      });
    }).catch(error1 => popupAjaxError(error1)).finally(() => {
      this.bookmarkCreatePromise = null;
    });
  }
  onShowMenu() {
    if (!this.existingBookmark) {
      this.onBookmark();
    }
  }
  onRegisterApi(api1) {
    this.dMenu = api1;
  }
  onEditBookmark() {
    this._openBookmarkModal();
  }
  onCloseMenu() {
    this.quicksaved = false;
  }
  async onRemoveBookmark() {
    try {
      const response1 = await this.bookmarkManager.delete();
      this.bookmarkManager.afterDelete(response1, this.existingBookmark.id);
      this.toasts.success({
        duration: 1500,
        data: {
          icon: "trash-alt",
          message: I18n.t("bookmarks.deleted_bookmark_success")
        }
      });
    } catch (error1) {
      popupAjaxError(error1);
    } finally {
      this.dMenu.close();
    }
  }
  async onChooseReminderOption(option1) {
    if (this.bookmarkCreatePromise) {
      await this.bookmarkCreatePromise;
    }
    if (option1.id === TIME_SHORTCUT_TYPES.CUSTOM) {
      this._openBookmarkModal();
    } else {
      this.existingBookmark.selectedReminderType = option1.id;
      this.existingBookmark.selectedDatetime = option1.time;
      this.existingBookmark.reminderAt = option1.time;
      try {
        await this.bookmarkManager.save();
        this.toasts.success({
          duration: 1500,
          views: ["mobile"],
          data: {
            message: I18n.t("bookmarks.reminder_set_success")
          }
        });
      } catch (error1) {
        popupAjaxError(error1);
      } finally {
        this.dMenu.close();
      }
    }
  }
  async _openBookmarkModal() {
    this.dMenu.close();
    try {
      const closeData1 = await this.modal.show(BookmarkModal, {
        model: {
          bookmark: this.existingBookmark,
          afterSave: savedData1 => {
            return this.bookmarkManager.afterSave(savedData1);
          },
          afterDelete: (response1, bookmarkId1) => {
            this.bookmarkManager.afterDelete(response1, bookmarkId1);
          }
        }
      });
      this.bookmarkManager.afterModalClose(closeData1);
    } catch (error1) {
      popupAjaxError(error1);
    }
  }
}, setComponentTemplate(createTemplateFactory(
/*
  
    <DMenu
      {{didInsert this.setReminderShortcuts}}
      @identifier="bookmark-menu"
      @triggers={{array "click"}}
      class={{this.buttonClasses}}
      @title={{this.buttonTitle}}
      @label={{this.buttonLabel}}
      @icon={{this.buttonIcon}}
      @onClose={{this.onCloseMenu}}
      @onShow={{this.onShowMenu}}
      @onRegisterApi={{this.onRegisterApi}}
      @arrow={{false}}
    >
      <:content>
        <DropdownMenu as |dropdown|>
          {{#unless this.showEditDeleteMenu}}
            <dropdown.item class="bookmark-menu__title">
              {{icon "check-circle"}}
              <span>{{i18n "bookmarks.bookmarked_success"}}</span>
            </dropdown.item>
          {{/unless}}

          {{#if this.showEditDeleteMenu}}
            {{#if this.site.mobileView}}
              <dropdown.item class="bookmark-menu__title">
                {{icon "bookmark"}}
                <span>{{i18n "bookmarks.bookmark"}}</span>
              </dropdown.item>
            {{/if}}

            <dropdown.item
              class="bookmark-menu__row -edit"
              data-menu-option-id="edit"
            >
              <DButton
                @icon="pencil-alt"
                @label="edit"
                @action={{this.onEditBookmark}}
                @class="bookmark-menu__row-btn btn-transparent"
              />
            </dropdown.item>
            <dropdown.item
              class="bookmark-menu__row --remove"
              role="button"
              tabindex="0"
              data-menu-option-id="delete"
            >
              <DButton
                @icon="trash-alt"
                @label="delete"
                @action={{this.onRemoveBookmark}}
                @class="bookmark-menu__row-btn btn-transparent btn-danger"
              />
            </dropdown.item>

          {{else}}
            <dropdown.item class="bookmark-menu__row-title">
              {{i18n "bookmarks.also_set_reminder"}}
            </dropdown.item>

            <dropdown.divider />

            {{#each this.reminderAtOptions as |option|}}
              <dropdown.item
                class="bookmark-menu__row"
                data-menu-option-id={{option.id}}
              >
                <DButton
                  @label={{option.label}}
                  @translatedTitle={{this.reminderShortcutTimeTitle option}}
                  @action={{fn this.onChooseReminderOption option}}
                  @class="bookmark-menu__row-btn btn-transparent"
                />
              </dropdown.item>
            {{/each}}
          {{/if}}
        </DropdownMenu>
      </:content>
    </DMenu>
  
*/
{
  "id": "u+hZMHxA",
  "block": "[[[1,\"\\n    \"],[8,[32,0],[[16,0,[30,0,[\"buttonClasses\"]]],[4,[32,2],[[30,0,[\"setReminderShortcuts\"]]],null]],[[\"@identifier\",\"@triggers\",\"@title\",\"@label\",\"@icon\",\"@onClose\",\"@onShow\",\"@onRegisterApi\",\"@arrow\"],[\"bookmark-menu\",[28,[32,1],[\"click\"],null],[30,0,[\"buttonTitle\"]],[30,0,[\"buttonLabel\"]],[30,0,[\"buttonIcon\"]],[30,0,[\"onCloseMenu\"]],[30,0,[\"onShowMenu\"]],[30,0,[\"onRegisterApi\"]],false]],[[\"content\"],[[[[1,\"\\n        \"],[8,[32,3],null,null,[[\"default\"],[[[[1,\"\\n\"],[41,[51,[30,0,[\"showEditDeleteMenu\"]]],[[[1,\"            \"],[8,[30,1,[\"item\"]],[[24,0,\"bookmark-menu__title\"]],null,[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[32,4],[\"check-circle\"],null]],[1,\"\\n              \"],[10,1],[12],[1,[28,[32,5],[\"bookmarks.bookmarked_success\"],null]],[13],[1,\"\\n            \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"showEditDeleteMenu\"]],[[[41,[30,0,[\"site\",\"mobileView\"]],[[[1,\"              \"],[8,[30,1,[\"item\"]],[[24,0,\"bookmark-menu__title\"]],null,[[\"default\"],[[[[1,\"\\n                \"],[1,[28,[32,4],[\"bookmark\"],null]],[1,\"\\n                \"],[10,1],[12],[1,[28,[32,5],[\"bookmarks.bookmark\"],null]],[13],[1,\"\\n              \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n            \"],[8,[30,1,[\"item\"]],[[24,0,\"bookmark-menu__row -edit\"],[24,\"data-menu-option-id\",\"edit\"]],null,[[\"default\"],[[[[1,\"\\n              \"],[8,[32,6],null,[[\"@icon\",\"@label\",\"@action\",\"@class\"],[\"pencil-alt\",\"edit\",[30,0,[\"onEditBookmark\"]],\"bookmark-menu__row-btn btn-transparent\"]],null],[1,\"\\n            \"]],[]]]]],[1,\"\\n            \"],[8,[30,1,[\"item\"]],[[24,0,\"bookmark-menu__row --remove\"],[24,\"role\",\"button\"],[24,\"tabindex\",\"0\"],[24,\"data-menu-option-id\",\"delete\"]],null,[[\"default\"],[[[[1,\"\\n              \"],[8,[32,6],null,[[\"@icon\",\"@label\",\"@action\",\"@class\"],[\"trash-alt\",\"delete\",[30,0,[\"onRemoveBookmark\"]],\"bookmark-menu__row-btn btn-transparent btn-danger\"]],null],[1,\"\\n            \"]],[]]]]],[1,\"\\n\\n\"]],[]],[[[1,\"            \"],[8,[30,1,[\"item\"]],[[24,0,\"bookmark-menu__row-title\"]],null,[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[32,5],[\"bookmarks.also_set_reminder\"],null]],[1,\"\\n            \"]],[]]]]],[1,\"\\n\\n            \"],[8,[30,1,[\"divider\"]],null,null,null],[1,\"\\n\\n\"],[42,[28,[31,3],[[28,[31,3],[[30,0,[\"reminderAtOptions\"]]],null]],null],null,[[[1,\"              \"],[8,[30,1,[\"item\"]],[[24,0,\"bookmark-menu__row\"],[16,\"data-menu-option-id\",[30,2,[\"id\"]]]],null,[[\"default\"],[[[[1,\"\\n                \"],[8,[32,6],null,[[\"@label\",\"@translatedTitle\",\"@action\",\"@class\"],[[30,2,[\"label\"]],[28,[30,0,[\"reminderShortcutTimeTitle\"]],[[30,2]],null],[28,[32,7],[[30,0,[\"onChooseReminderOption\"]],[30,2]],null],\"bookmark-menu__row-btn btn-transparent\"]],null],[1,\"\\n              \"]],[]]]]],[1,\"\\n\"]],[2]],null]],[]]],[1,\"        \"]],[1]]]]],[1,\"\\n      \"]],[]]]]],[1,\"\\n  \"]],[\"dropdown\",\"option\"],false,[\"unless\",\"if\",\"each\",\"-track-array\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/bookmark-menu.js",
  "scope": () => [DMenu, array, didInsert, DropdownMenu, icon, i18n, DButton, fn],
  "isStrictMode": true
}), _BookmarkMenu), _BookmarkMenu), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "modal", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "toasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "site", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "quicksaved", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "setReminderShortcuts", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setReminderShortcuts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reminderShortcutTimeTitle", [action], Object.getOwnPropertyDescriptor(_class.prototype, "reminderShortcutTimeTitle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onBookmark", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onBookmark"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onShowMenu", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onShowMenu"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onRegisterApi", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onRegisterApi"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onEditBookmark", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onEditBookmark"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onCloseMenu", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onCloseMenu"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onRemoveBookmark", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onRemoveBookmark"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onChooseReminderOption", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onChooseReminderOption"), _class.prototype)), _class);
export { BookmarkMenu as default };